import { genericColors } from './genericColors';

export const customTheme = props => {
  return {
    genericColors: { ...genericColors },
    themeColors: {
      controlBar: {
        background: props[0] ? `#${props[0]}` : genericColors.grayAlabaster,
        borderBottomColor: props[1] ? `#${props[1]}` : genericColors.grayDim,
        leftPanel: {
          goBackButtonColor: props[2] ? `#${props[2]}` : genericColors.gray,
          goBackButtonColorOnHover: props[3]
            ? `#${props[3]}`
            : genericColors.blueBright,
          goBackButtonColorOnActive: props[4]
            ? `#${props[4]}`
            : genericColors.blueMain,
          dividerColor: props[5] ? `#${props[5]}` : genericColors.grayLight,
          buttonColor: props[6] ? `#${props[6]}` : genericColors.grayDark,
          buttonColorOnHover: props[3]
            ? `#${props[3]}`
            : genericColors.blueBright,
          buttonColorOnActive: props[4]
            ? `#${props[4]}`
            : genericColors.blueMain,
        },
        rightPanel: {
          icons: {
            bookmarkIcon: {
              colorOnEmpty: props[7]
                ? `#${props[7]}`
                : genericColors.orangePeachy,
              colorOnEmptyAndHover: props[8]
                ? `#${props[8]}`
                : genericColors.orangeMain,
              colorOnFilled: props[8]
                ? `#${props[8]}`
                : genericColors.orangeMain,
              colorOnFilledAndHover: props[9]
                ? `#${props[9]}`
                : genericColors.orangeSoft,
            },
            bookshelfIcon: {
              booksIconColor: props[2] ? `#${props[2]}` : genericColors.gray,
              booksIconColorOnHover: props[3]
                ? `#${props[3]}`
                : genericColors.blueBright,
              circleBackground: props[0]
                ? `#${props[0]}`
                : genericColors.grayAlabaster,
              iconColor: props[10]
                ? `#${props[10]}`
                : genericColors.blueSeagull,
              iconColorOnActive: props[4]
                ? `#${props[4]}`
                : genericColors.blueMain,
            },
            settingsIcon: {
              color: props[11] ? `#${props[11]}` : genericColors.grayBoulder,
              colorOnHover: props[3]
                ? `#${props[3]}`
                : genericColors.blueBright,
              colorOnActive: props[4] ? `#${props[4]}` : genericColors.blueMain,
            },
            searchIcon: {
              color: props[11] ? `#${props[11]}` : genericColors.grayBoulder,
              colorOnHover: props[3]
                ? `#${props[3]}`
                : genericColors.blueBright,
              colorOnActive: props[4] ? `#${props[4]}` : genericColors.blueMain,
            },
          },
        },
      },
      settingsDropdown: {
        background: props[0] ? `#${props[0]}` : genericColors.grayAlabaster,
        borderColor: props[5] ? `#${props[5]}` : genericColors.grayLight,
        boxShadow: '0px 1px 10px rgba(0, 0, 0, 0.15)',
        dividerColor: props[1] ? `#${props[1]}` : genericColors.grayDim,
        textColor: props[6] ? `#${props[6]}` : genericColors.grayDark,
        pageModeTogglerBorder: props[5]
          ? `#${props[5]}`
          : genericColors.grayLight,
        pageModeTogglerColor: props[5]
          ? `#${props[5]}`
          : genericColors.grayLight,
        oldReaderLinkColor: props[4] ? `#${props[4]}` : genericColors.blueMain,
        oldReaderLinkColorOnHover: props[3]
          ? `#${props[3]}`
          : genericColors.blueBright,
      },
      sidebars: {
        background: props[12] ? `#${props[12]}` : 'rgba(235, 235, 235, 0.95)',
        toc: {
          textColor: props[13] ? `#${props[13]}` : genericColors.blackMatt,
          subTextColor: props[6] ? `#${props[6]}` : genericColors.grayDark,
          dividerColor: props[5] ? `#${props[5]}` : genericColors.grayLight,
          itemColor: props[4] ? `#${props[4]}` : genericColors.blueMain,
          itemColorOnHover: props[3]
            ? `#${props[3]}`
            : genericColors.blueBright,
          itemColorOnActive: props[13]
            ? `#${props[13]}`
            : genericColors.blackMatt,
          itemBackgroundOnActive: props[16]
            ? `#${props[16]}`
            : 'rgba(106, 160, 241, 0.2)',
        },
        thumbnails: {
          textColor: props[6] ? `#${props[6]}` : genericColors.grayDark,
          textColorOnActive: props[14]
            ? `#${props[14]}`
            : genericColors.blackTotal,
        },
        bookmarks: {
          headerBackground: props[16]
            ? `#${props[16]}`
            : 'rgba(106, 160, 241, 0.2)',
          pagesColor: props[4] ? `#${props[4]}` : genericColors.blueMain,
          textColor: props[13] ? `#${props[13]}` : genericColors.blackMatt,
          dateColor: props[6] ? `#${props[6]}` : genericColors.grayDark,
          removeColor: props[15] ? `#${props[15]}` : genericColors.redMilano,
          dividerColor: props[17]
            ? `#${props[17]}`
            : 'rgba(200, 200, 200, 0.6)',
        },
      },
      pageContainer: {
        background: props[0] ? `#${props[0]}` : genericColors.grayAlabaster,
      },
      footer: {
        background: props[0] ? `#${props[0]}` : genericColors.grayAlabaster,
        textColor: props[14] ? `#${props[14]}` : genericColors.blackTotal,
        progressBar: {
          trackColor: props[5] ? `#${props[5]}` : genericColors.grayLight,
        },
      },
      arrowButtons: {
        color: props[5] ? `#${props[5]}` : genericColors.grayLight,
        dropShadow: 'drop-shadow(4px 2px 6px rgba(0, 0, 0, 0.35))',
      },
      zoomButtons: {
        background: props[18] ? `#${props[18]}` : 'rgba(255, 255, 255, 0.95)',
        backgroundOnHover: props[19] ? `#${props[19]}` : genericColors.white,
        backgroundOnActive: props[20]
          ? `#${props[20]}`
          : genericColors.bridalWhite,
        borderColor: props[1] ? `#${props[1]}` : genericColors.grayDim,
        borderColorOnHover: props[21]
          ? `#${props[21]}`
          : genericColors.orangeDim,
        borderColorOnActive: props[21]
          ? `#${props[21]}`
          : genericColors.orangeDim,
        boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.1)',
        boxShadowOnHover: '0px 1px 6px rgba(252, 122, 30, 0.2)',
        iconColor: props[5] ? `#${props[5]}` : genericColors.grayLight,
        iconColorOnHover: props[8] ? `#${props[8]}` : genericColors.orangeMain,
        iconColorOnActive: props[8] ? `#${props[8]}` : genericColors.orangeMain,
      },
      beta: {
        button: {
          background: props[0] ? `#${props[0]}` : genericColors.grayAlabaster,
          backgroundOnHover: props[0]
            ? `#${props[0]}`
            : genericColors.grayAlabaster,
          backgroundOnActive: props[22]
            ? `#${props[22]}`
            : genericColors.springWood,
          border: props[1] ? `#${props[1]}` : genericColors.grayDim,
          boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
          iconColor: props[23] ? `#${props[23]}` : genericColors.orangeLight,
          iconColorOnHover: props[9]
            ? `#${props[9]}`
            : genericColors.orangeSoft,
          iconColorOnActive: props[8]
            ? `#${props[8]}`
            : genericColors.orangeMain,
        },
        modal: {
          background: props[0] ? `#${props[0]}` : genericColors.grayAlabaster,
          borderColor: props[5] ? `#${props[5]}` : genericColors.grayLight,
          textColor: props[14] ? `#${props[14]}` : genericColors.blackTotal,
          buttonBackground: props[9]
            ? `#${props[9]}`
            : genericColors.orangeSoft,
          smallTextColor: props[11]
            ? `#${props[11]}`
            : genericColors.grayBoulder,
        },
      },
    },
    fontSizes: {
      base: '1rem',
      small: '0.88875rem',
      tiny: '0.79rem',
    },
    backgroundTransitionTime: '0.25s',
  };
};
